@if (visible$ | async) {
<ul>
  @for (item of parts$ | async; track item) {
  <li>{{ item.quantity }} x <ish-product-name ishProductContext [sku]="item.sku" [link]="false" /></li>
  }
</ul>
}
